<template>
    <div>
        <el-form-item label=" " label-width="10px">
            <el-radio v-model="B_指定时间" :label="1" @change="setValue">任何时间都可以使用</el-radio>
            <el-radio v-model="B_指定时间" :label="0" @change="setValue">指定使用时间</el-radio>
        </el-form-item>
        <el-form-item label="指定日期" v-if="!B_指定时间">
            <el-date-picker @change="setValue" clearable v-model="J_指定日期" type="daterange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"> </el-date-picker>
        </el-form-item>
        <el-form-item label="指定几号" v-if="!B_指定时间">
            <el-checkbox-group v-model="J_指定几号" @change="setValue" style="line-height: 30px;">
                <el-checkbox v-for="item in 30" :disabled="获取天是否禁用(item)" :label="item" :key="item" style="width: 40px;"></el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="指定周几" v-if="!B_指定时间">
            <el-checkbox-group v-model="J_指定周几" @change="setValue" style="line-height: 30px;">
                <el-checkbox v-for="item in 星期list" :disabled="获取星期是否禁用(item)" :label="item" :key="item"></el-checkbox>
            </el-checkbox-group>
        </el-form-item>
        <el-form-item label="指定时间" v-if="!B_指定时间">
            <div v-for="(row,index) in J_指定时间段" :key="index" style="display: flex;">
                <el-time-picker @change="setValue" style="flex:1;" :picker-options="{format:'HH:mm' }" format="HH:mm" value-format="HH:mm:00" clearable is-range :value="row" @input="e=>{$setArrArr(J_指定时间段,index,e);setValue();}" range-separator="至" start-placeholder="开始时间" end-placeholder="结束时间" placeholder="选择时间范围"></el-time-picker>
                <el-button @click="()=>{J_指定时间段.Remove(row);setValue();}" slot="append">移除</el-button>
            </div>
            <el-button :disabled="J_指定时间段.length>9" @click="()=>{J_指定时间段.push(['00:00:00','00:00:00']);setValue();}"> 添加时间段</el-button>
        </el-form-item>
        <el-form-item label="文字说明" v-if="!B_指定时间">
            <div style="color: red;line-height: 20px;padding: 10px 0;" v-html="str"></div>
        </el-form-item>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: () => {
                return {
                    B_指定时间: 1,
                    J_指定日期: [],
                    J_指定几号: [],
                    J_指定周几: [],
                    J_指定时间段: [],
                }
            },
        }
    },
    data() {
        return {
            B_指定时间: 1,
            J_指定日期: [],
            J_指定几号: [],
            J_指定周几: [],
            J_指定时间段: [],

            星期list: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],

            str: '',
        }
    },
    mounted() {
        this.updateVal();
    },
    methods: {
        updateVal() {
            if (this.value == null) this.$emit('input', {
                B_指定时间: 1,
                J_指定日期: [],
                J_指定几号: [],
                J_指定周几: [],
                J_指定时间段: [],
            });
            this.B_指定时间 = (this.value || {}).B_指定时间;
            if (typeof (this.value || {}).B_指定时间 == 'undefined') this.B_指定时间 = 1;
            this.J_指定日期 = (this.value || {}).J_指定日期 || [];
            this.J_指定几号 = (this.value || {}).J_指定几号 || [];
            this.J_指定周几 = (this.value || {}).J_指定周几 || [];
            this.J_指定时间段 = (this.value || {}).J_指定时间段 || [];
        },
        获取天是否禁用(item) {
            if ((this.J_指定日期 || []).length > 1) {
                let strart = this.J_指定日期[0];
                let end = this.J_指定日期[1];
                let 相差天数 = Math.floor((end - strart) / (24 * 3600 * 1000));
                if (相差天数 > 60) return false;   //怕有2月的情况

                let 天list = [];
                for (let index = 0; index <= 相差天数; index++) {
                    天list.push(strart.getDate());
                    strart = strart.addDays(1);
                }
                return !天list.includes(item)
            }
            return false;
        },
        获取星期是否禁用(item) {
            // 礼拜天 0   1-6
            if ((this.J_指定日期 || []).length > 1) {
                let strart = this.J_指定日期[0];
                let end = this.J_指定日期[1];
                let 相差天数 = Math.floor((end - strart) / (24 * 3600 * 1000));
                if (相差天数 > 7) return false;

                let 天list = [];
                for (let index = 0; index <= 相差天数; index++) {
                    天list.push(this.星期list[strart.getDay()]);
                    strart = strart.addDays(1);
                }
                return !天list.includes(item)
            }
            return false;
        },
        setValue() {
            let v = {
                B_指定时间: this.B_指定时间,
                J_指定日期: this.B_指定时间 ? [] : this.J_指定日期 || [],
                J_指定几号: this.B_指定时间 ? [] : this.J_指定几号 || [],
                J_指定周几: this.B_指定时间 ? [] : this.J_指定周几 || [],
                J_指定时间段: this.B_指定时间 ? [] : this.J_指定时间段 || [],
            };
            this.$emit('input', v);
            this.str = this.$解析时段(v);
        },
    },
}
</script>

<style>
</style>